import { BlogEntity, BlogType } from '../types/blog.types';
import { PaginationParams, ResponseType } from '../types/shared.types';
import { api } from './api';

export const createBlog = (data: FormData) =>
  api.post<ResponseType<BlogEntity>>(`/v1/blogs`, data, {
    headers: { 'content-type': 'multipart/form-data' },
  });

/** `type` narrows the list to blog posts or case studies; without it, all. */
export const getAllBlogs = (params: PaginationParams<{ type?: BlogType }>) =>
  api.get<ResponseType<BlogEntity[]>>(`/v1/blogs`, { params });

export const getBlogById = (id: string | number) =>
  api.get<ResponseType<BlogEntity>>(`/v1/blogs/${id}`);

export const editBlog = (id: string | number, data: FormData) =>
  api.put<ResponseType<BlogEntity>>(`/v1/blogs/${id}`, data, {
    headers: { 'content-type': 'multipart/form-data' },
  });

export const deleteBlogById = (id: string | number) =>
  api.delete<ResponseType<null>>(`/v1/blogs/${id}`);
